@if (isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
} @else {
  <div>
    <my-ibox boxTitle="go-neb configuration">
      <div class="my-ibox-content">
        <p>{{'go-neb supports many different types of bots, each of which is listed below. Here you can configure which bots this go-neb instance should use.' | translate}}</p>

        <table class="table table-striped table-condensed table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>{{'Description' | translate}}</th>
              <th class="text-center">{{'Actions' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            @for (bot of nebConfig.integrations; track bot) {
              <tr>
                <td>{{ bot.displayName }}</td>
                <td>{{ bot.description }}</td>
                <td class="text-right">
                  @if ((bot.isEnabled && hasConfig(bot) && !isUpstream)) {
                    <span class="editButton" (click)="editBot(bot)" (keydown)="editBot(bot)">
                      <i class="fa fa-pencil-alt"></i>
                    </span>
                  }
                  @if (!isOverlapping(bot)) {
                    <ui-switch [checked]="bot.isEnabled" size="small" [disabled]="isUpdating"
                    (change)="toggleBot(bot)"></ui-switch>
                  }
                  @if (isOverlapping(bot)) {
                    <ui-switch [checked]="false" size="small" [disabled]="true"
                    ngbTooltip="This bot is handled by another go-neb instance"></ui-switch>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </my-ibox>
  </div>
}
